/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_gov_011: Question = {
  id: 'gov-011-biodiversite-sad-pmad',
  oldId: '11',
  title: 'Prise en compte de la biodiversité dans le schéma d’aménagement et de développement (SAD) ou Plan métropolitain d’aménagement et de développement (PMAD)',
  number: '1.11',
  description: [''],
  type: QuestionType.ACTIVITY,
  idEM: 1,
  frequency: 1,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      score: '0',
      scoringFct: (data: string[]) => parseFloat(data[0]),
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

export const question_gov_011_v2: Question = question_gov_011;
export const question_gov_011_v3: Question = question_gov_011;
